export const tr = {
    canNotBeEmpty: 'Değer boş bırakılamaz',
    emptyRegions: 'Bölgeler seçilmedi',
    finishTimeShouldBeGreaterThanStartTime:
        'Gösterimlerin bitiş tarihi ile saati, başlangıç tarihi ile saatinden önce veya aynı olamaz',
    incorrectVersion:
        'Sürüm yanlış belirtildi. Lütfen sürümü tam sayı veya ondalık kesir şeklinde belirtin. Ondalık kısmı ayırmak için nokta kullanın. Örneğin: 6.14',
    invalidDate: 'Tarih yanlış',
    invalidUrl: "Mobil uygulamanın URL'si hatalı",
    invalidValue: 'Değer hatalı',
    invalidYandexUid: 'YandexUid hatalı. Lütfen, uzunluğu 17 ile 19 karakter arasında bir sayı veya maske değeri girin',
    multipleVersions: 'Hedefleme, sürüm belirten tek bir öğeye sahip olabilir',
    numericInvalidValue: 'Girilen değer sayı değil',
    numericNegativeValue: 'Girilen değer sıfırdan küçük',
    suggestInvalidValue: 'Bilinmeyen değer. Lütfen, listeden bir değer seçin.',
    unknownError: 'Bilinmeyen hata',
    valueShouldBeLessThan: 'Girilen değer en fazla {maxValue} veya buna eşit olmalıdır',
    valueShouldBeMoreThan: 'Girilen değer en az {maxValue} veya buna eşit olmalıdır'
};
